import React, { useState, useRef, useEffect } from "react";
import SortByUpIcon from "./../../img/icons/sortByUp.svg";
import SortByDownIcon from "./../../img/icons/sortByDown.svg";
import DownArrow from "./../../img/icons/down-arrow.svg";
import localization from "../../data/config";
import { getUrlParameter } from "../../utilities/filters";
import { useDispatch, useSelector } from "react-redux";
import { sortToHash, updateHash } from "../../utilities/hash";
import * as HASH from "../../constants/config/hash";
import { sortNewest, sortOldest } from "../../utilities/arrays";
import { NEWEST, OLDEST } from "../../constants/config/parameters";
import { SET_PARTS } from "../../constants/actions/parts";
import "./style.css";
import MediaQuery from "react-responsive";
import breakpoints from "../../constants/breakpoints";

const SortBy = (props) => {
  const dispatch = useDispatch();
  const parts = useSelector((state) => state.parts);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(props.options[0].value);
  const selectRef = useRef(null);

  const getSortValue = () => {
    let currentURL = new URLSearchParams(window.location.hash);
    return getUrlParameter("#/sort", currentURL) || getUrlParameter("sort", currentURL);
  };

  const getSortLabel = (optionValue) => {
    const activeOption =  props.options.find(item => item.value === optionValue);
    return activeOption ? activeOption.label : "";
  }

  const handleSelectChange = (option) => {
    setSelectedOption(option);

    if (option === "Newest") {
      dispatch({
        type: SET_PARTS,
        payload: { parts: sortNewest(parts.allData) },
      });
      updateHash(HASH.SORT, sortToHash([NEWEST]));
    } else {
      dispatch({
        type: SET_PARTS,
        payload: { parts: sortOldest(parts.allData) },
      });
      updateHash(HASH.SORT, sortToHash([OLDEST]));
    }
  };

  const handleOptionClick = (option) => {
    handleSelectChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    let getSelectedSortValue = getSortValue();

    if (getSelectedSortValue === undefined || getSelectedSortValue === null) {
      getSelectedSortValue = props.options[0].value;
    }
    setSelectedOption(getSelectedSortValue);

    let sortSelectBox = document.querySelector("#sort-by");
    sortSelectBox && sortSelectBox.addEventListener("change", (e) => {
      setSelectedOption(e.target.value);
    });

    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <MediaQuery minDeviceWidth={breakpoints.tablet.max}>
        <div className="sorting"  tabIndex={0} role="combobox" aria-label={localization.sortBy}  aria-expanded={isOpen}>
          <label htmlFor="sort">{localization.sortBy}</label>
          <div className="custom-select-box" ref={selectRef}>
            <div
              className={`select-box ${isOpen ? "open" : ""}`}
              onClick={() => setIsOpen(!isOpen)}
            >
              <span id="sort-by">{getSortLabel(selectedOption)}</span>

              {isOpen ? (
                <img src={SortByUpIcon} alt="sort up arrow icon" aria-hidden="true"/>
              ) : (
                <img src={SortByDownIcon} alt="sort down arrow icon" aria-hidden="true"/>
              )}
            </div>

            {isOpen && (
              <ul className="sortBy-options">
                {props.options.map((option, index) => (
                  <li
                    key={index}
                    onClick={() => handleOptionClick(option.value)}
                  >
                    {option.label}
                  </li>
                ))}
              </ul>
            )}

            <select
              className="hidden-select-laptop"
              id="sort"
              value={selectedOption}
              onChange={(e) => handleSelectChange(e.target.value)}
            >
              {props.options.map((option, index) => (
                <option
                  className="options-mobile"
                  key={index}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </MediaQuery>

      <MediaQuery maxDeviceWidth={breakpoints.tablet.min - 1}>
        {props.renderDeskMarkup ? (
          <div className="sorting desktopMarkupinMobile" tabIndex={0}  role="combobox" aria-label={localization.sortBy} aria-expanded={isOpen}>
            <label htmlFor="sort">{localization.sortBy}</label>
            <div className="custom-select-box" ref={selectRef}>
              <div
                className={`select-box ${isOpen ? "open" : ""}`}
                onClick={() => setIsOpen(!isOpen)}
              >
                <span id="sort-by">{getSortLabel(selectedOption)}</span>

                {isOpen ? (
                  <img src={SortByUpIcon} alt="sort up arrow icon" aria-hidden="true"/>
                ) : (
                  <img src={SortByDownIcon} alt="sort down arrow icon" aria-hidden="true"/>
                )}
              </div>

              {isOpen && (
                <ul className="sortBy-options">
                  {props.options.map((option, index) => (
                    <li
                      key={index}
                      onClick={() => handleOptionClick(option.value)}
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              )}

              <select
                className="hidden-select-laptop"
                id="sort"
                value={selectedOption}
                onChange={(e) => handleSelectChange(e.target.value)}
              >
                {props.options.map((option, index) => (
                  <option
                    className="options-mobile"
                    key={index}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          <div className="sorting-mobile">
            <label htmlFor="sort">{localization.sortBy}</label>
            <div className="custom-select-box-mobile" ref={selectRef}>
              <div
                className={`select-box-mobile ${isOpen ? "open" : ""}`}
                onClick={() => setIsOpen(!isOpen)}
              >
                <span id="sort-by">{getSortLabel(selectedOption)}</span>

                {isOpen ? (
                  <img
                    src={DownArrow}
                    className="dropdownIcon-mobile"
                    alt="sort up arrow icon"
                  />
                ) : (
                  <img src={DownArrow} alt="sort up arrow icon" />
                )}
              </div>

              {isOpen && (
                <ul className="sortBy-options-mobile">
                  {props.options.map((option, index) => (
                    <li
                      key={index}
                      onClick={() => handleOptionClick(option.value)}
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </MediaQuery>
    </>
  );
};

export default SortBy;
